// storybook-check-ignore
import React from 'react';

import { Button } from '@opendoor/bricks/core';

import { GlobalNavSVG } from './GlobalNavSVG';

interface HeaderMenuButtonProps {
  navMenuId: string;
  navMenuButtonId: string;
  isVisible: boolean;
  handleMenuClick: () => void;
  ctaRef: React.RefObject<HTMLButtonElement>;
}

export const HeaderMenuButton: React.FC<HeaderMenuButtonProps> = ({
  navMenuId,
  navMenuButtonId,
  isVisible,
  handleMenuClick,
  ctaRef,
}) => {
  return (
    <Button
      analyticsName="cosmos-landing-page-header-menu-button"
      aria-label="Navigation menu"
      aria-controls={navMenuId}
      aria-expanded={isVisible ? 'true' : 'false'}
      aria-haspopup="true"
      id={navMenuButtonId}
      ref={ctaRef}
      border={0}
      color="warmgrey950"
      height="24px"
      minHeight="24px"
      width="24px"
      p={0}
      outline="0"
      onClick={handleMenuClick}
      _hover={{
        borderRadius: 'roundedSquare',
        color: 'brandBlue600',
      }}
      _active={{
        borderRadius: 'roundedSquare',
        scale: 1,
      }}
      _focus={{
        borderRadius: 'roundedSquare',
        color: 'warmgrey950',
        outline: 0,
      }}
      _focusVisible={{
        borderRadius: 'roundedSquare',
        color: 'brandBlue600',
        outline: 0,
      }}
      style={{
        background: 'none',
        borderRadius: 'roundedSquare',
      }}
    >
      <GlobalNavSVG isOpen={isVisible} />
    </Button>
  );
};
